import { BusAlertIcon } from './BusAlertIcon';

/**
 * author: Google
 * id 85DD64A3-9215-41F0-9C94-92C180D7BA05
 * name bus-alert
 * version: 2.7.94
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/bus-alert.svg
 * tags
 * - Alert / Error 
 * - Transportation + Road 
 */
export const BusWarningIcon = BusAlertIcon;
export default BusWarningIcon